<!-- 地图和tabs -->
<template>
    <div class="right-section">
        <div id="mapBox"></div>
        <!-- 轨迹分类 -->
        <div class="track-type">
            <otp-select
                :optionArr="trackTypeOption"
                :mValue="trackType"
                :prop="'trackType'"
                @getSelectValue="setTrackType"
            ></otp-select>
        </div>
        <!-- 轨迹分类 -->
        <!-- 轨迹列表 -->
        <div class="track-list" :style="{ width: arrowFlag ? '60%' : '30px' }">
            <div class="track-main">
                <div class="telescoping bigData-btn-track-list" @click="arrowFlag = !arrowFlag">
                    轨迹列表
                    <i v-if="arrowFlag" class="arrow el-icon-arrow-right"></i>
                    <i v-else class="arrow el-icon-arrow-left"></i>
                </div>
                <div class="track-content" v-show="arrowFlag">
                    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane :label="trackName" name="first"></el-tab-pane>
                    </el-tabs>
                    <vxe-table show-overflow :data="locationData" ref="xTable1" height="290">
                        <vxe-column type="seq" title="序号" width="100"></vxe-column>
                        <vxe-column field="trackingDate" title="时间"></vxe-column>
                        <vxe-column
                            field="trackingLocationName"
                            :title="'地点(共' + locationData.length + '条)'"
                        ></vxe-column>
                        <vxe-column field="speed" title="速度(km/h)"></vxe-column>
                        <vxe-column field="isAbnormalName" title="异常"></vxe-column>
                    </vxe-table>
                </div>
            </div>
        </div>
        <!-- 轨迹列表 -->
        <!-- 轨迹播放器 -->
        <!-- waybillMapIsInitialized && locationData.length && locationData.length === 1 -->
        <div id="map-controller" v-if="handleMapControllerShow()">
            <div class="map-controller-play" @click="isPlaying = !isPlaying">
                <i class="el-icon-video-play" v-if="!isPlaying" @click="start"></i>
                <i class="el-icon-video-pause bigData-btn-track-playback" v-if="isPlaying" @click="pause"></i>
            </div>
            <div class="map-controller-progress">
                <el-progress :percentage="tracedInPercent"></el-progress>
                <div class="map-controller-progress-time">
                    <div>{{ locationData[locationData.length - 1].trackingDate }}</div>
                    <div>{{ locationData[0].trackingDate }}</div>
                </div>
            </div>
            <el-button-group class="map-controller-speed-switch">
                <el-button :type="speed === 1 ? 'primary' : 'default'" @click="changeSpeed(1)">x1</el-button>
                <el-button :type="speed === 2 ? 'primary' : 'default'" @click="changeSpeed(2)">x2</el-button>
                <el-button :type="speed === 4 ? 'primary' : 'default'" @click="changeSpeed(4)">x4</el-button>
                <el-button :type="speed === 8 ? 'primary' : 'default'" @click="changeSpeed(8)">x8</el-button>
            </el-button-group>
        </div>
        <!-- 轨迹播放器 -->
        <div class="tab-box">
            <el-tabs v-model="eventActiveName">
                <el-tab-pane label="事件管理" name="1">
                    <div class="administration">
                        <div>发车单号:{{ dispatchData.dispatchNo }}</div>
                        <p style="word-spacing: 15px;">车牌号:{{ dispatchData.vehicleCard }} 司机:{{ dispatchData.driver }}</p>
                        <el-steps align-center>
                            <el-step
                                :title="item.eventName"
                                v-for="(item, index) in stepList"
                                :key="index"
                            >
                                <template slot="icon">
                                    <div class="step-icon"></div>
                                </template>
                                <template slot="description">
                                    <div>{{ item.siteAddress }}</div>
                                    <div v-if="item.requireDepartTime">
                                        要求发车时间:
                                        {{ item.requireDepartTime }}
                                    </div>
                                    <div v-if="item.requireArriveTime">
                                        要求抵达时间:
                                        {{ item.requireArriveTime }}
                                    </div>
                                    <div v-if="item.actDepartTime">
                                        实际发车时间:
                                        {{ item.actDepartTime }}
                                    </div>
                                    <div v-if="item.actualArriveDate">
                                        实际到车时间:
                                        {{ item.actualArriveDate }}
                                    </div>
                                    <div v-if="item.arrivalTime">
                                        实际抵达时间:
                                        {{ item.arrivalTime }}
                                    </div>
                                </template>
                            </el-step>
                        </el-steps>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="轨迹重拉" name="2">
                    <div class="administration">
                        <el-row>
                            <el-col :span="6" class="time-picker-wrapper">
                                <span class="time-label">开始时间：</span>
                                <el-date-picker
                                    v-model="beginDate"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择">
                                </el-date-picker>
                            </el-col>
                            <el-col :span="6" class="time-picker-wrapper">
                                <span class="time-label">结束时间：</span>
                                <el-date-picker
                                    v-model="endDate"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择">
                                </el-date-picker>
                            </el-col>
                            <el-col :span="2">
                                <el-tooltip
                                    content="抵达之后才可重新获取北斗轨迹"
                                    :disabled="+dispatchData.dispatchStatus >= 50"
                                    placement="top"
                                >
                                    <el-button
                                        type="primary"
                                        :disabled="!dispatchData.dispatchStatus || +dispatchData.dispatchStatus < 50 || !beginDate || !endDate"
                                        @click="rePullTrackList"
                                    >获取轨迹</el-button>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                        <el-steps align-center>
                            <el-step
                                :title="item.eventName"
                                v-for="(item, index) in stepList"
                                :key="index"
                            >
                                <template slot="icon">
                                    <div class="step-icon"></div>
                                </template>
                                <template slot="description">
                                    <div>{{ item.siteAddress }}</div>
                                    <div v-if="item.requireDepartTime">
                                        要求发车时间:
                                        {{ item.requireDepartTime }}
                                    </div>
                                    <div v-if="item.requireArriveTime">
                                        要求抵达时间:
                                        {{ item.requireArriveTime }}
                                    </div>
                                    <div v-if="item.actDepartTime">
                                        实际发车时间:
                                        {{ item.actDepartTime }}
                                    </div>
                                    <div v-if="item.actualArriveDate">
                                        实际到车时间:
                                        {{ item.actualArriveDate }}
                                    </div>
                                    <div v-if="item.arrivalTime">
                                        实际抵达时间:
                                        {{ item.arrivalTime }}
                                    </div>
                                </template>
                            </el-step>
                        </el-steps>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api.js';
import otpSelect from '@/components/lots/otpSelect';
import { getMonitorEvent, getDispatchNoLocationCurrent, getDispatchNoLocationPoint, getZjxlPointByDispatch  } from '../../../../api/performanceDispatchInRoadMonitor.js';
import { infoMap, TraceRouteController } from './map.js';
import dayjs from 'dayjs';

const mapController = new TraceRouteController();

export default {
    components: {
        otpSelect
    },
    props: {
        mapAndTabsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            trackType: '50',
            trackName: '综合',
            trackTypeOption: [],
            waybillMapIsInitialized: true, // 是否已经初始化
            isPlaying: true, // 是否播放轨迹
            speed: 1, // 播放速度
            tracedInPercent: 0, // 播放轨迹百分比
            dispatchData: {},
            arrowFlag: false,
            locationData: [],
            activeName: 'first',
            stepList: [],
            eventActiveName: '1',
            dictionaryCode: [
                'TRACKING_TYPE'
            ],
            orderTakingFlag: false,
            beginDate: '', // 拉取轨迹开始时间
            endDate: '' // 拉取轨迹结束时间
        };
    },
    watch: {
        mapAndTabsData: {
            handler (val) {
                this.dispatchData = val;
                // 默认综合轨迹，有设备号则查询设备的轨迹
                this.trackType = val.deviceNo ? '34' : '50';
                if (val.dispatchNo) {
                    this.updateMap(this.dispatchData);
                } else {
                    mapController.removeMarkers();
                    mapController.onClear();
                    this.stepList = [];
                    this.locationData = [];
                }
            },
            deep: true
        },
        stepList: {
            handler (val) {
                if (val.length) {
                    const actDepartTime = val[0].actDepartTime;
                    // 多个卸货站点，实际抵达时间取最大值
                    const arrivalTime = val
                        .filter(item => item.eventType === '10' && item.arrivalTime)
                        .reduce((max, item) => {
                            if (!max) return item.arrivalTime;
                            const currentTime = dayjs(item.arrivalTime);
                            const maxTime = dayjs(max);
                            return currentTime.isAfter(maxTime) ? item.arrivalTime : max;
                        }, null);
                    // 当系统时间≥实际发车时间，开始时间默认填充实际发车时间
                    this.beginDate = actDepartTime && dayjs().isAfter(dayjs(actDepartTime)) ? actDepartTime : '';
                    // 当系统时间≥实际抵达时间，结束时间默认填充实际抵达时间
                    this.endDate = arrivalTime && dayjs().isAfter(dayjs(arrivalTime)) ? arrivalTime : '';
                } else {
                    this.beginDate = '';
                    this.endDate = '';
                }
            },
            deep: true
        }
    },
    mounted () {
        infoMap('mapBox', mapController);
        dictWithUrl(this.dictionaryCode.join(',')).then((res) => {
            for (const key in res.data) {
                if (key) {
                    for (const childKey in res.data[key]) {
                        if (childKey) {
                            this.trackTypeOption.push({
                                value: childKey,
                                label: res.data[key][childKey]
                            });
                        }
                    }
                }
            }
        });
    },
    methods: {
        // 重置播放速度和监听事件
        resetParams () {
            mapController.setSpeed(this.speed);
            mapController.onMove((event) => {
                this.tracedInPercent = +event.tracedInPercent.toFixed();
                if (this.tracedInPercent === 100) {
                    this.isPlaying = false;
                }
            });
        },
        // 处理轨迹回放显示
        handleMapControllerShow () {
            if (this.waybillMapIsInitialized && this.locationData.length) {
                if (this.locationData.length === 1) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        /**
         * @description 查询事件信息列表
         */
        getEvent (dispatchNo) {
            this.stepList = [];
            return getMonitorEvent({ dispatchNo }).then((res) => {
                if (res && +res.code === 0) {
                    if (res.data.length) {
                        this.stepList = res.data;
                        mapController.setRouteData(res.data);
                    }
                }
            });
        },
        /**
         * @description 查询货车当前地址信息
         */
        getCurrent (dispatchNo) {
            return getDispatchNoLocationCurrent({ dispatchNo }).then((res) => {
                if (res && +res.code === 0) {
                    if (res.data) {
                        if (res.data.longitude && res.data.latitude) {
                            // 发车单状态为已抵达(50, 60, 100)不需要展示货车当前地址信息
                            if (![50, 60, 100].includes(+this.dispatchData.dispatchStatus)) {
                                mapController.setCarMarker(res.data);
                            }
                        }
                    }
                }
            });
        },
        /**
         * @description 手动拉取北斗轨迹
         */
        rePullTrackList () {
            const params = {
                dispatchNo: this.dispatchData.dispatchNo,
                beginDate: this.beginDate,
                endDate: this.endDate
            };
            this.$confirm('确定按照所选日期范围重新获取北斗轨迹吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '执行中...';
                        getZjxlPointByDispatch(params)
                            .then(res => {
                                if (res && +res.code === 0) {
                                    this.$message.success(res.data || '轨迹拉取成功');
                                    this.updateMap(this.dispatchData);
                                }
                                done();
                            })
                            .catch(() => { })
                            .finally(() => {
                                instance.confirmButtonLoading = false;
                                done();
                            });
                    } else {
                        done();
                    }
                }
            }).catch(() => { });
        },
        /**
         * @description 查询打点信息列表接口
         */
        getPoint (dispatchNo, deviceNo, orderTakingFlag) {
            this.locationData = [];
            return getDispatchNoLocationPoint({ dispatchNo, deviceNo, trackingType: this.trackType }).then((res) => {
                if (res && +res.code === 0) {
                    if (res.data.length) {
                        this.locationData = this.formatTotalDataList(res.data);
                        if (orderTakingFlag) {
                            const dispatchDate = this.stepList[0].actDepartTime;
                            const pointDate = res.data[res.data.length - 1].trackingDate;
                            // 当轨迹表第一个轨迹点的采集时间晚于发车时间，则不显示接单点
                            orderTakingFlag = !(pointDate > dispatchDate);
                        }
                        mapController.setCarRouteData(res.data, orderTakingFlag);
                        this.resetParams();
                    }
                }
            });
        },
        formatTotalDataList (data) {
            if (!data.length) return [];
            data.forEach(e => {
                e.isAbnormalName = e.isAbnormal === '0' ? '正常' : e.isAbnormal ? '异常' : '';
            });
            return data;
        },
        handleClick (tab, event) { },
        start () {
            if (!this.locationData.length) return;
            mapController.start();
        },
        pause () {
            if (!this.locationData.length) return;
            mapController.pause();
        },
        // 设置播放速度
        changeSpeed (val) {
            this.speed = val;
            mapController.setSpeed(val);
        },
        // 设置轨迹分类
        setTrackType (data, label) {
            Object.assign(this, data);
            this.trackName = label;
            if (this.dispatchData.dispatchNo) {
                this.updateMap(this.dispatchData);
            } else {
                this.$message.warning('请选择左侧列表发车单');
            }
        },
        updateMap (data) {
            mapController.removeMarkers();
            mapController.onClear();
            this.waybillMapIsInitialized = true;
            this.isPlaying = false;
            this.tracedInPercent = 0;
            this.speed = 1;
            // 发运类型为整车且是中交轨迹并且shippingType = 1(整车)才显示接单点
            this.orderTakingFlag = +this.trackType === 6 && data.shippingType === 1;
            Promise.all([
                this.getEvent(data.dispatchNo),
                this.getCurrent(data.dispatchNo),
                this.getPoint(data.dispatchNo, data.deviceNo, this.orderTakingFlag)
            ]).then(() => {
                setTimeout(() => {
                    mapController.handleViewport();
                });
            });
        }
    }
};
</script>
<style lang='less' scoped>
.right-section {
    position: relative;
    height: 100%;
    overflow-y: auto;
    #mapBox {
        height: 60%;
    }
    .tab-box {
        height: 34%;
        padding-left: 10px;
    }
}

.track-type {
    z-index: 998;
    position: absolute;
    top: 0;
    right: 0;
}

.track-list {
    z-index: 998;
    position: absolute;
    top: 5%;
    right: 0;
    height: 350px;
    background-color: #fff;
    transition: width 0.5s;
    .track-main {
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        .telescoping {
            cursor: pointer;
            display: flex;
            align-items: center;
            width: 24px;
            height: 100%;
            padding: 0 5px;
            text-align: center;
            word-wrap: break-word;
            .arrow {
                cursor: pointer;
                position: absolute;
                left: 8px;
                bottom: 5%;
                border-radius: 50%;
                border: 0.5px solid #000;
            }
        }
        .track-content {
            flex: 1;
        }
    }
}

#map-controller {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 6%;
    background-color: #f5f5f5;
    .map-controller-play {
        cursor: pointer;
        display: inline-block;
        font-size: 25px;
        margin: 0 10px;
    }
    .map-controller-progress {
        flex-grow: 1;

        .map-controller-progress-time {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #666;
            font-size: 14px;
            padding-right: 40px;
        }
    }
    .map-controller-speed-switch {
        margin-right: 20px;
        .el-button {
            width: 35px;
            padding: 7px 10px;
        }
    }
}

.administration {
    color: #333;
    font-size: 12px;
    font-weight: bold;
}

.time-picker-wrapper {
    display: flex;
    align-items: center;
    .el-date-editor {
        width: 60%;
    }
    .time-label {
        font-size: 12px;
        color: #666
    }
}

/deep/ .el-steps {
    max-height: 200px;
    overflow: hidden;
    overflow-y: auto;
}

/deep/.el-step {
    margin-top: 30px;
    .el-step__icon.is-text {
        width: unset;
        border-radius: unset;
        border: unset;
        border-color: inherit;
        .step-icon {
            width: 10px;
            height: 10px;
            border-radius: 14px;
            background: #cacaca;
        }
    }
    .is-wait {
        color: #333;
    }
}
</style>

<style lang="less">
// .BMap_stdMpPan {
//     display: block !important;
// }
// .BMap_pop div {
//     background-color: #22293b !important;
// }
// .BMap_pop > div:nth-last-of-type(3) {
//     background-color: #22293b !important;
// }
// .BMap_pop > div:nth-last-of-type(3) img {
//     display: none;
// }
// .BMap_pop > div:nth-last-of-type(3) {
//     width: 0 !important;
//     height: 0 !important;
//     border: 20px solid #22293b !important;
//     border-right-color: transparent !important;
//     border-bottom-color: transparent !important;
//     background: transparent !important;
// }
// .BMap_bubble_pop {
//     // background-color: #22293b !important;
//     .BMap_bubble_top {
//         height: 0 !important;
//     }
// }

.trace-hover-ctn {
    // color: #fff;
    font-size: 12px;
    width: auto;
    height: auto;
    // background-color: #22293b;
}
</style>
